export default __webpack_public_path__ + "static/media/zari_1.dbffbbd6.jpeg";